export default __webpack_public_path__ + "static/media/ct_food1.81d6554f.jpeg";